enum UIMessage {
  ArchivedMatch = 'Archived Match',
  RestoredMatch = 'Restored Match',
  MatchAccepted = 'Match Accepted',
  MatchRejected = 'Match Rejected',
  NewVerificationsImported = 'New verifications imported',
  RecordAlreadyReviewed = 'Record already reviewed.',
  RecordWasRemoved = 'This record has been removed.',
  DatasetFileUploadSuccess = 'Successfully uploaded. It may take up to 24 hours for the new file to be available.',
  VerificationProcessing = 'Verification in process...',
  ImportProcessing = 'Import in process...',
  DeleteConfirmation = 'Are you sure you want to remove this record?',
  DeleteFolderConfirmation = 'Are you sure you want to delete this folder?',
  DeleteFileConfirmation = 'Are you sure you want to delete this file?',
  FolderContainsAttachedFiles = 'Folder contains attached files',
  FileAttachedToChecklistItems = 'File attached to checklist items'
}

export default UIMessage;
